import React from "react";
import { Flex, chakra } from "@chakra-ui/react";
import Fade from "src/components/Fade";

const EnhancedVideo = chakra("video");

export default React.forwardRef(function Video(
  {
    src,
    in: inProp,
    onEntered,
    onError,
    onEnded,
    onPlay,
    onCanPlayThrough,
    onDurationChange,
    onTimeUpdate,
    ratio
  },
  ref
) {
  return (
    <Fade
      in={inProp}
      onEnter={onEntered}
      duration={{
        enter: 0.3,
        exit: 0
      }}
    >
      <Flex
        alignItems="center"
        justifyContent="center"
        width="100%"
        height="100%"
      >
        <EnhancedVideo
          ref={ref}
          src={src}
          onPlay={onPlay}
          onError={onError}
          onEnded={onEnded}
          onCanPlayThrough={onCanPlayThrough}
          onDurationChange={onDurationChange}
          onTimeUpdate={onTimeUpdate}
          preload="auto"
          {...(ratio > 1 && { width: "100%" })}
          height="100%"
          maxHeight="90vh"
          objectPosition="center center"
        />
      </Flex>
    </Fade>
  );
});
